import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js';

const DetailTrackRelease = ({data,mode,onClose,onSubmit, open}) => {


    const [formData,setFormData] = useState({
        catalog_number : "",
        i_inline: "",
        isrc: "",
        lyric: "",
        lyric_language_name: "",
        maker: "",
        parental_guidance_name: "",
        preview_start: "",
        production_year: "",
        secondary_song_type_name: "",
        secondary_sub_genre_name: "",
        song_code: "",
        sub_genre_name: "",
        channels: "",
        sub_title: "",
        title: "",
        track_title_language_name:""
    })

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };
    

    useEffect(() => {
        if (data) {
            const trackList = data.original || data;
            setFormData({
                catalog_number : trackList.catalog_number,
                i_inline: trackList.i_inline,
                isrc: trackList.isrc,
                lyric: trackList.lyric,
                lyric_language_name: trackList.lyric_language_name,
                maker: trackList.maker,
                parental_guidance_name: trackList.parental_guidance_name,
                preview_start: trackList.preview_start,
                production_year: trackList.production_year,
                secondary_song_type_name: trackList.secondary_song_type_name,
                secondary_sub_genre_name: trackList.secondary_sub_genre_name,
                song_code: trackList.song_code,
                channels: trackList.song_channels,
                sub_title: trackList.sub_title,
                title: trackList.title,
                track_title_language_name: trackList.title_language_name,
            })
        }
    },[data])

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit) {
          onSubmit(formData);
        }
      };
    
      const handleClose = () => {
        if (onClose) {
          onClose();
        }
      };

      const isReadOnly = mode === 'detail';


  return (
      <div
          className={`modal fade ${open ? "show" : ""}`}
          tabIndex="-1"
          style={{ display: open ? "block" : "none" }}
          aria-hidden={!open}
      >
          <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                  <div className="modal-header justify-content-between">
                      <h5 className="modal-title">{mode === 'detail' ? 'Detail Track Music' : 'View Track Music'}</h5>
                      <button type="button" className="close" onClick={handleClose}>
                          <Icon icon="mdi:close-circle" width={24} height={24} />
                      </button>
                  </div>
                  <div className="modal-body">
                    <div>
                        {/* <form onSubmit={handleSubmit}> */}
                            
                            <div className="row">
                            {[
                                { label: 'Judul Release', value: 'title' },
                                { label: 'Sub Title', value: 'sub_title' },
                                { label: 'Secondary Song Type', value:'secondary_song_type_name'},
                                { label: 'Sub Genre', value: 'sub_genre_name' },
                                { label: 'Catalog Number', value: 'catalog_number' },
                                { label: 'Production year', value: 'production_year' },
                                { label: 'Preview Start', value: 'preview_start' },
                                { label: 'Maker', value: 'maker' },
                                { label: 'lyric Language', value: 'lyric_language_name' },
                                { label: 'Inline', value: 'i_inline' },
                                { label: 'ISRC', value: 'isrc' },
                                { label: 'Parental Guidance', value: 'parental_guidance_name' },
                            ].map((item, index) => (
                                <div className="col-md-6 mb-3" key={item.value + index}>
                                    <label className="col-form-label" htmlFor={item.value}>
                                        {item.label}:
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id={item.value}
                                        name={item.value}
                                        defaultValue={formData[item.value]}
                                        readOnly={isReadOnly}
                                    />
                                </div>
                            ))}
                                <div className="col-md-12 mb-3">
                                    <div className='row p-10'>
                                        <label className="col-form-label" htmlFor="lyric">Lyric: </label>
                                        <textarea 
                                        className='form-control'
                                        name="lyric" 
                                        id="lyric"
                                        defaultValue={formData.lyric}
                                        disabled={isReadOnly}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            {

                            }
                            <div className="d-flex justify-content-end gap-2 mt-3">
                                {!isReadOnly && (
                                <button type="submit" className="btn btn-primary">
                                    {mode === 'create' ? 'Create' : 'Submit'}
                                </button>
                                )}
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                Close
                                </button>
                            </div>
                        {/* </form> */}
                    </div>
                  </div>
              </div>
          </div>
      </div>
    );
}

export default DetailTrackRelease